import React from 'react';
import styles from './BusinessCard.module.css';
import { Phone, Zap, MapPin, Lock } from 'lucide-react'; 
import StarRating from '../components/StarRating/startRating';
import VerifiedBadge from '../components/VerifiedBadge/VerifiedBadge';

// CRITICAL: Ensure 'isGuest' is in this list below
const BusinessCard = ({ business, isSelected, onCardClick, isGuest }) => {
    const {
        businessName,
        description,
        overallRating,
        businessProfileOverview,
        isHighlighted,
        isSponsored,
        streetNumber,
        streetName,
        suburb,
        phone,
        isVerified,
        isDocApproved, // This is here
    } = business;

    const profilePic = businessProfileOverview?.profile_Pic;

    // --- 1. GUEST LOGIC (Masking) ---
    // If isGuest is TRUE, we force masked data. 
    // If FALSE, we proceed to standard checks.
    
    let displayPhone;
    if (isGuest) {
        displayPhone = (
            <span style={{ fontStyle: 'italic', color: '#777', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Lock size={12} /> Login to view
            </span>
        );
    } else {
        // User is Logged In: Only show full phone if Verified
        displayPhone = isVerified 
            ? phone 
            : (phone ? `${phone.substring(0, 4)}...` : '');
    }

    let displayAddress;
    if (isGuest) {
        displayAddress = suburb; // Guest only sees Suburb
    } else {
        // User is Logged In: Show address based on verification
        displayAddress = isVerified 
            ? `${streetNumber} ${streetName}, ${suburb}` 
            : `${suburb}`;
    }

    return (
        <div
            className={`${styles.businessCard} ${isSelected ? styles.selected : ''} ${isHighlighted ? styles.highlighted : ''}`}
            onClick={() => onCardClick(business.businessId)}
        >
            {isSponsored && <div className={styles.sponsoredBanner}><Zap size={16} /> Sponsored</div>}
            <div className={styles.cardContent}>
                <div className={styles.leftColumn}>
                    {profilePic ? (
                        <img src={profilePic} alt={businessName} className={styles.profilePic} />
                    ) : (
                        <div className={styles.avatarFallback}>{businessName ? businessName.charAt(0) : ''}</div>
                    )}
                </div>
                <div className={styles.middleColumn}>

                    <h3 className={styles.businessName} style={{ display: 'flex', alignItems: 'center' }} >
                        <span>{businessName}</span> 
                        {/* VITAL: Check both Verified AND DocApproved */}
                        {isVerified && isDocApproved && <VerifiedBadge size={24} />}
                    </h3>                    
                    
                    <div className={styles.ratingContainer}>
                        {overallRating ? (
                            <>
                                <StarRating ratings={overallRating} />
                                <span className={styles.ratingText}>{overallRating.toFixed(1)}</span>
                            </>
                        ) : (
                            <span className={styles.newToBuildStart}>New to BuildStart</span>
                        )}
                    </div>

                    <p className={styles.description}>
                        {description && description.length > 80 ? description.substring(0, 80) + '...' : description}
                    </p>
                    
                    <div className={styles.addressSection}>
                        <MapPin size={16} />
                        <span>{displayAddress}</span>
                    </div>
                    
                    <div className={styles.phoneSection}>
                        <Phone size={16} />
                        <span>{displayPhone}</span>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default BusinessCard;